module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/special_offer_image_2-96ceade5922313b4a87e12528dd246c3.png";